import api from './client'

export interface CreateAgentSessionPayload {
  project?: string
}

export async function createAgentSession(data: CreateAgentSessionPayload = {}) {
  const res = await api.post('/claudeagent/sessions', data)
  return res.data
}

export async function checkAgentAvailability() {
  const res = await api.get('/claudeagent/check-availability')
  return res.data as { available: boolean; claude_path: string; message: string }
}

export interface AgentSessionState {
  exists: boolean
  running: boolean
}

// Whether a stored agent session id is still alive server-side (and whether a
// run is in flight on it) — used after a page refresh to decide between
// reattaching to the old session and lazily creating a new one.
export async function getAgentSessionState(sessionId: string) {
  const res = await api.get(`/claudeagent/sessions/${sessionId}/state`)
  return res.data as AgentSessionState
}
